<template>
  <div 
    v-if="iconVisible" 
    class="zdocs-defence"
  >
    <el-tooltip 
      :content="$t('保护状态')" 
      effect="dark" 
      placement="top"
    >
      <defenceSvg @click.native="checkMessage" />
    </el-tooltip>

    <co-confirm
      class="defence-confirm"
      v-model="dialogVisible"
      :title="title"
      :content="content"
      :sure-btn="confirmButton"
      :icon-name="confirmIcontype"
      :describe="confirmDescribe"
      :only-one="onlyOne"
      ref="defenceDialog"
    >
    </co-confirm>
  </div>
</template>

<script>
import coConfirm from "components/common/confirm/index.vue";
import * as Util from "js/util/util";
import defenceSvg from "./defence-svg.vue";

export default {
  name: "DocsDefenceIcon",
  components: {
    coConfirm,
    defenceSvg
  },
  props: {
    fileInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false, // 是否显示confirm，这里通过v-model绑定显示，开始置为false
      onlyOne: false
    };
  },
  computed: {
    title() {
      const title = this.$t("提示");
      return title;
    },
    content() {
      const excelContent = `${this.$t("该表格处于保护状态")}`;
      const docContent = `${this.$t("该文档处于保护状态")}`;
      const { mime_type: mimeType } = this.fileInfo;
      return Util.isExcel(mimeType) ? excelContent : docContent;
    },
    confirmButton() {
      const confirmDescribe = this.$t("取消");
      return confirmDescribe;
    },
    confirmIcontype() {
      const confirmIcontype = "#warn";
      return confirmIcontype;
    },
    confirmDescribe() {
      // TODO 接口连调：用户名
      const { creator, creator_uid: creatorId } = this.fileInfo;
      const subCommon = `${this.$t("本地打开、更新版本、移动等操作可能受限。")}`;
      const excelTxt = `${subCommon}</br>${this.$t('在zOffice编辑中关闭"<strong>允许区域保护</strong>"项可恢复非保护状态。')}`;
      const docTxt = `${subCommon}</br>${this.$t('联系所有者 {t} 在zOffice编辑中关闭"<strong>跟踪更改</strong>"可恢复非保护状态。', { t: `${creator}` })}`;
      const ownDocTxt = `${subCommon}</br>${this.$t('在zOffice编辑中关闭"<strong>跟踪更改</strong>"可恢复非保护状态。')}`;
      const { mime_type: mimeType } = this.fileInfo;
      const { uid: userId } = this.$store.getters.userInfo
      if(creatorId !== userId) {
        return Util.isExcel(mimeType) ? excelTxt : docTxt;
      }else {
        return Util.isExcel(mimeType) ? excelTxt : ownDocTxt; 
      }
      
    },
    iconVisible() {
      // TODO 接口连调：特殊状态-展示icon
      const { protection_status: status } = this.fileInfo;
      if (status === "online_edit_only"){
        return true;
      } 
      if (status === "normal"){
        return false;
      } 
    }
  },

  methods: {
    checkMessage() {
      this.dialogVisible = true
      document.body.appendChild(this.$refs.defenceDialog.$el)
    },
  }
};
</script>

<style lang="less">
.confirm-mock{
  background: rgba(127,127,127,.5);
}
.zdocs-defence {
  display: inline-block;
  position: relative;
  top: 1px;
  width: 16px;
  height: 18px;

  svg {
    width: 16px;
    height: 14px;
    cursor: pointer;
  }
}
#defence.el-tooltip {
  margin-bottom: 4px;
  text-align: center;
}
.card-view {
  .zdocs-defence {
    height: 20px;
    vertical-align: top;

    svg {
      position: absolute;
      top: 50%;
      margin-top: -6px;
    }
  }
}
.el-tooltip__popper.is-dark {
  transform: translate(-1px, -3px);
  border-radius: 4px;
}
.defence-confirm {
  .c-btn {
    display: none;
  }
}
</style>
